import { PropType, reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import useOrganizationService from '@/services/OrganizationService';

type Props = SetupProps<typeof OrganizationModalNameUpdateSetupService.props>
type OrganizationData = {
  name: string
  email: string
}

export default class OrganizationModalNameUpdateSetupService extends BaseSetupService<Props> {
	static readonly props = {
		organization: {
			type: Object as PropType<OrganizationData>,
			required: true as const,
		},
	};

	private _modal?: OrionModal;
	private readonly state = reactive({
		organization: {
			name: undefined as Undef<string>,
			email: undefined as Undef<string>,
		},
		feedback: {
			checking: false,
			message: undefined as Undef<string>,
			success: false,
		},
	});

	get feedback () { return this.state.feedback; }

	get isValid () {
		return this.state.feedback.success
      && !this.state.feedback.checking
      && !!this.organizationName?.length;
	}

	get organizationName () { return this.state.organization.name; }
	set organizationName (val) { this.state.organization.name = val; }

	get organizationEmail () { return this.state.organization.email; }
	set organizationEmail (val) { this.state.organization.email = val; }


	constructor (props?: Props, _modal?: OrionModal) {
		super(props);
		this._modal = _modal;
	}

	protected async onBeforeMountAsync () {
		Object.assign(this.state.organization, this.props.organization);
	}


	async generateAndVerifyMailAsync (email: string) {
		this.state.feedback.checking = true;
		this.state.feedback.message = undefined;

		this.organizationEmail = useOrganizationService().generateMail(email);

		if (this.organizationName && this.organizationEmail) {
			const res = await useOrganizationService().checkOrganizationNameAndEmailAsync(
				this.organizationName,
				this.organizationEmail,
			);

			this.state.feedback.message = res.message;
			this.state.feedback.success = res.success;
			this.state.feedback.checking = false;
		}
	}

	async saveAsync () {
		if (this.organizationGuard() && this.isValid) {
			const payload = {
				name: this.organizationName,
				email: this.organizationEmail,
			};

			await useOrganizationService().updateNameAndEmailAsync(this.self.organization.id, payload);

			this._modal?.trigger('saved', payload);
		}
	}
}
